import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import ChannelSingleton from './../../../components/Epg/ChannelsSingleton';

class LinealChannelsTask extends AbstractRequestTask {
    constructor(userId) {
        super();
        this.userId = userId;
    }

    getParams() {
        const params = super.getParams();
        const user_id = this.userId || null;
        return Object.assign({}, params, { user_id }, this.getExtraParams());
    }

    getExtraParams(){
        if (ChannelSingleton.hasTimeshiftAPA()) {
            return {
                "npvr": 1,
                "ts": 1,
            }
        }
        else{
            return {};
        }
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/payway/linealchannels`;
    }

    getShowErrorModal(){
        return DISABLE_MODAL_RETRIES;
    }

    success(data, b) {
        this.resolve(data);
    }

    getRetriesNumber() {
        return 0;
    }
}

export default LinealChannelsTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/LinealChannelsTask.js